import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import { Box } from "@material-ui/core";
import { GlobalContext } from "../../../store";
import QuestionsBuilderContentComponent from "../../../modules/settings/components/questions-builder/questions-builder-content/questions-builder-content.component";
import SupportBlockComponent from "../../../components/support/support.component";

export const QuestionsBuilderPage = () => {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.QUESTIONS_BUILDER"));
      setPageTitle(t("PAGE_META_TITLES.QUESTIONS_BUILDER"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="role-contain">
      <Box
        className="content"
        style={{ minWidth: "1420px", maxWidth: "1420px" }}
      >
        <SettingsHead
          title={t("PAGES_HEAD.SETTINGS.QUESTIONS_BUILDER_TITLE")}
          subTitle={t("PAGES_HEAD.SETTINGS.QUESTIONS_BUILDER_SUB_TITLE")}
        />
        <QuestionsBuilderContentComponent />
        <SupportBlockComponent />
      </Box>
    </Box>
  );
};
